var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useContext } from 'react';
import { useQuery } from 'react-query';
import { maestroApiCall } from '../../helpers/maestroDataSource';
import { MaestroQueryClientContext } from './MaestroQueryClientContext';
import { CentralProviderContext } from '../../centralProviderContext/CentralProviderContext';
export var useMaestroQuery = function (params) {
    var _a, _b;
    var api = params.api, queryKey = params.queryKey, options = params.options, includeTenant = params.includeTenant, authToken = params.authToken;
    var defaultBaseURL = useContext(MaestroQueryClientContext).baseURL;
    var selectedGrant = useContext(CentralProviderContext).selectedGrant;
    var tenantId = (selectedGrant || { id: undefined }).id;
    var customerNumber = ((selectedGrant === null || selectedGrant === void 0 ? void 0 : selectedGrant.accounts[0]) || { customer_number: undefined }).customer_number;
    var maestroAPI = __assign(__assign({}, api), { endpoint: (_a = api.endpoint) !== null && _a !== void 0 ? _a : '', baseURL: ((_b = api.baseURL) !== null && _b !== void 0 ? _b : defaultBaseURL) || '' });
    var query = useQuery(queryKey, function (_a) {
        var queryKeyParams = _a.queryKey;
        var apiParams = queryKeyParams[1] || {};
        if (includeTenant) {
            apiParams.tenant_id = tenantId;
            apiParams.customer_number = customerNumber;
        }
        return maestroApiCall(maestroAPI, apiParams, undefined, undefined, undefined, authToken);
    }, options);
    return query;
};
//# sourceMappingURL=useMaestroQuery.js.map